import * as yup from '@if/core/yup'
import {
  BaseWorksheetFormConfig,
  BaseWorksheetFormValues,
  useBaseWorksheetFormFields,
  useBaseWorksheetFormReady,
} from '@src/components/WorksheetForm'
import { useMemo } from 'react'

export type CalculatorValues = BaseWorksheetFormValues

export type CalculatorSchema = ReturnType<typeof useCalculatorSchema>

export const useCalculatorSchema = (config: BaseWorksheetFormConfig) => {
  const fields = useBaseWorksheetFormFields(config)

  return useMemo(
    () =>
      yup.object({
        amountRequested: fields.amountRequested,
        paymentPlanId: fields.paymentPlanId,
        term: fields.term,
        paymentFrequency: fields.paymentFrequency,
        activationDate: fields.activationDate,
        firstPaymentDate: fields.firstPaymentDate,
        includeProtection: fields.includeProtection,
        isHighEstimate: fields.isHighEstimate,
      }),
    [fields],
  )
}

export const useCalculatorForm = (config: BaseWorksheetFormConfig) => {
  const schema = useCalculatorSchema(config)
  const isReady = useBaseWorksheetFormReady(config)

  const defaultValues = useMemo(() => (isReady ? (schema.getDefault() as CalculatorValues) : null), [isReady, schema])

  return { schema, defaultValues, isReady }
}
